import { createContext } from 'react';
import { IdentityInterface } from '../interfaces/Identity.d';

export const IdentityContext = createContext<IdentityInterface>({
  loading: true,
  isAuth: false,
  token: null,
  setIdentity: () => {},
});
